import React from 'react';
import Header from '../../components/header/index';
import Footer from '../../components/footer/index';
import http from '../../http/http';
import global from '../../http/common';
import feedback_bg from '../../static/imgs/feedback_bg.png';
import wyfk_ic from '../../static/imgs/wyfk_ic.png';
import fkxq_ic from '../../static/imgs/fkxq_ic.png';
import CommonBtn from '../../components/btn/index';
import { Tabs, Input, message, Empty } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { RightOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import './index.css';

const { TabPane } = Tabs;
const { TextArea } = Input;

class Feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackList: {
        all: [],
        my: []
      },
      materialInfo: {
      },
      pagePublicNo: 1,
      pageAccessNo: 1,
      pageSize: 20,
      titleInputValue: "",
      contentInputValue: "",
      mobileNoInputValue: "",
      boxContentItemType: 0,
      feedbackListCount: 0,
      isLogin: false,
      activeKey: "1"
    };
  }
  componentDidMount () {
    this.setState({
      isLogin: global.isLogin()
    }, () => {
      if (this.state.isLogin) {
        this.notesListPublic();
        this.notesListAccess();
        this.setState({
          activeKey: "2"
        });
      } else {
        this.notesListPublic();
        this.setState({
          activeKey: "1"
        });
      }
    });
  }
  render () {
    let commonBtnIcon = (
      <img src={wyfk_ic} style={{
        width: "18px",
        height: "18px",
        marginRight: "5px"
      }}></img>
    );
    let allListContent = (
      <TabPane tab="全部反馈" key="1">
        {
          this.state.feedbackList.all.map((data, index) => {
            return (
              <div className="feedback_item" key={"feedback_item_" + index} onClick={this.feedbackItemClick.bind(this, data, 0)}>
                <div className="item_status status_0" style={{ display: data.replyContent && data.replyContent != "" ? "block" : "none" }}>已回复</div>
                <div className="item_status status_1" style={{ display: data.replyContent && data.replyContent != "" ? "none" : "block" }}>未回复</div>
                <div className="item_title">{data.title}</div>
                <div className="item_time">{data.sendedTime && data.sendedTime != "" ? data.sendedTime.split(" ")[0] : ""}</div>
                <RightOutlined />
              </div>
            )
          })
        }
        <div className="refresh_bg">
          <div className="more" style={{ display: this.state.pageSize == this.state.feedbackList.all.length ? "block" : "none" }} onClick={this.refrePublicFeedbackList.bind(this)}>加载更多...</div>
          <div className="nomore" style={{ display: this.state.pageSize == this.state.feedbackList.all.length ? "none" : "block" }}>暂无更多</div>
        </div>
      </TabPane>
    );
    if (!this.state.feedbackList.all.length) {
      allListContent = (
        <TabPane tab="全部反馈" key="1">
          <Empty description={this.state.isLogin ? "暂未查询到记录" : "暂未查询到记录,请登录后查看"} style={{
            color: "var(--light_text_color)"
          }}></Empty>
        </TabPane>
      );
    }
    let myListContent = (
      <TabPane tab="我的反馈" key="2">
        {
          this.state.feedbackList.my.map((data, index) => {
            return (
              <div className="feedback_item" key={"feedback_item_" + index} onClick={this.feedbackItemClick.bind(this, data, 1)}>
                <div className="item_status status_0" style={{ display: data.replyContent && data.replyContent != "" ? "block" : "none" }}>已回复</div>
                <div className="item_status status_1" style={{ display: data.replyContent && data.replyContent != "" ? "none" : "block" }}>未回复</div>
                <div className="item_title">{data.title}</div>
                <div className="item_time">{data.sendedTime && data.sendedTime != "" ? data.sendedTime.split(" ")[0] : ""}</div>
                <RightOutlined />
              </div>
            )
          })
        }
        <div className="refresh_bg">
          <div className="more" style={{ display: this.state.pageSize == this.state.feedbackList.my.length ? "block" : "none" }} onClick={this.refreAccessFeedbackList.bind(this)}>加载更多...</div>
          <div className="nomore" style={{ display: this.state.pageSize == this.state.feedbackList.my.length ? "none" : "block" }}>暂无更多</div>
        </div>
      </TabPane>
    );
    if (!this.state.feedbackList.my.length) {
      myListContent = (
        <TabPane tab="我的反馈" key="2">
          <Empty description={this.state.isLogin ? "暂未查询到记录" : "暂未查询到记录,请登录后查看"} style={{
            color: "var(--light_text_color)"
          }}></Empty>
        </TabPane>
      );
    }
    let listHeader = (
      <CommonBtn type="common" text="我要反馈" newStyle={{ background: "var(--blue_highlight_color)", color: "white", height: "35px", width: "120px", display: "flex", justifyContent: "center", alignItems: "center" }} children={commonBtnIcon} btnClick={this.feedbackClick.bind(this)}></CommonBtn>
    );
    if (!this.state.isLogin) {
      listHeader = (
        <div className="goLoginDiv">您暂未登录账户，请先登录后进行反馈</div>
      );
    }
    let boxContentItem_list = (
      <div>
        {
          listHeader
        }
        <div className="content">
          <Tabs activeKey={this.state.activeKey} onTabClick={this.onTabClick.bind(this)}>
            {
              allListContent
            }
            {
              myListContent
            }
          </Tabs>
        </div>
      </div>
    );
    let boxContentItem_input = (
      <div className="boxContentItem_input">
        <div className="first_layout" onClick={this.backToTop.bind(this)}>
          <LeftOutlined></LeftOutlined>
          <div>返回</div>
        </div>
        <div className="second_layout">
          <div>反馈内容</div>
          <div className="integrant">[必填]</div>
        </div>
        <Input onChange={this.titleInputOnChange.bind(this)} maxLength="50" placeholder="请输入反馈标题(最多50字)" style={{
          marginTop: "10px"
        }} />
        <TextArea onChange={this.contentInputOnChange.bind(this)} showCount maxLength={800} placeholder="请输入反馈内容" style={{
          marginTop: "10px"
        }} autoSize={{ minRows: 4, maxRows: 6 }} />
        <div className="second_layout">
          <div>联系方式</div>
          <div className="choice">[选填]</div>
        </div>
        <Input onChange={this.mobileNoInputOnChange.bind(this)} maxLength="11" placeholder="请输入您的手机号码" style={{
          marginTop: "10px"
        }} />
        <div className="submit_bg">
          <CommonBtn type="common" text="提交" newStyle={{ color: "white", background: "var(--blue_highlight_color)" }} btnClick={this.submitClick.bind(this)}></CommonBtn>
        </div>
      </div>
    );
    let statusMap = this.getMaterialStatus(this.state.materialInfo.replyContent);
    let boxContentItem_material = (
      <div className="boxContentItem_material">
        <div className="first_layout" onClick={this.backToTop.bind(this)}>
          <LeftOutlined></LeftOutlined>
          <div>返回</div>
        </div>
        <div className="second_layout">
          <img src={fkxq_ic}></img>
          <div>反馈详情</div>
        </div>
        <div className="material_title">
          {this.state.materialInfo.title}
        </div>
        <div className="material_time">
          {this.state.materialInfo.sendedTime}
        </div>
        <TextArea onChange={this.contentInputOnChange.bind(this)} showCount maxLength={800} placeholder="请输入反馈内容" defaultValue={this.state.materialInfo.content} style={{
          marginTop: "10px",
          pointerEvents: statusMap.status != "0" ? "none" : ""
        }} autoSize={{ minRows: 4, maxRows: 6 }} />
        <div className="material_section">联系方式</div>
        <Input onChange={this.mobileNoInputOnChange.bind(this)} maxLength="11" placeholder="请输入您的手机号码" defaultValue={this.state.materialInfo.mobileNo} style={{
          marginTop: "10px",
          pointerEvents: statusMap.status != "0" ? "none" : ""
        }} />
        <div className="status_layout">
          <div className="material_section">回复状态</div>
          <div className="material_status" style={{ color: statusMap.color }}>{statusMap.str}</div>
        </div>
        <div className="btn_layout">
          <CommonBtn type="common" text="修改反馈" newStyle={{
            color: statusMap.status != "0" ? "var(--light_text_color)" : "white",
            background: statusMap.status != "0" ? "var(--light_shoal_color)" : "var(--blue_highlight_color)",
            pointerEvents: statusMap.status != "0" ? "none" : ""
          }} btnClick={this.changeFeedback.bind(this)}></CommonBtn>
          <div className="space"></div>
          <CommonBtn type="common" text="删除反馈" newStyle={{ color: "white", background: "#F04040" }} btnClick={this.deleteFeedback.bind(this)}></CommonBtn>
        </div>
      </div>
    );
    let boxContentItem_all = (
      <div className="boxContentItem_material">
        <div className="first_layout" onClick={this.backToTop.bind(this)}>
          <LeftOutlined></LeftOutlined>
          <div>返回</div>
        </div>
        <div className="second_layout">
          <img src={fkxq_ic}></img>
          <div>反馈详情</div>
        </div>
        <div className="material_title">
          {this.state.materialInfo.title}
        </div>
        <div className="material_time">
          {this.state.materialInfo.sendedTime}
        </div>
        <TextArea onChange={this.contentInputOnChange.bind(this)} defaultValue={this.state.materialInfo.content} style={{
          marginTop: "10px",
          pointerEvents: "none"
        }} autoSize={{ minRows: 4, maxRows: 6 }} />
        <div style={{
          display: this.state.materialInfo.replyContent && this.state.materialInfo.replyContent != "" ? "block" : "none"
        }}>
          <div className="status_layout">
            <div className="material_section">官方回复</div>
            <div className="material_time">{this.state.materialInfo.replyTime}</div>
          </div>
          <TextArea onChange={this.contentInputOnChange.bind(this)} defaultValue={this.state.materialInfo.replyContent} style={{
            marginTop: "10px",
            pointerEvents: "none"
          }} autoSize={{ minRows: 4, maxRows: 6 }} />
        </div>
      </div>
    );
    let boxContentItem = null;
    if (this.state.boxContentItemType == 0) {
      boxContentItem = boxContentItem_list;
    } else if (this.state.boxContentItemType == 1) {
      boxContentItem = boxContentItem_input;
    } else if (this.state.boxContentItemType == 2) {
      boxContentItem = boxContentItem_material;
    } else if (this.state.boxContentItemType == 3) {
      boxContentItem = boxContentItem_all;
    }
    return (
      <div className='feedback_index_wrap'>
        <Header></Header>
        <div className="feedback_content">
          <div className="title" style={{
            backgroundImage: "url(" + require("../../static/imgs/feedback_bg.png").default + ")",
            backgroundSize: "center/80%",
            backgroundRepeat: "no-repeat"
          }}>
            <div className="text l_text">赛百UI问题反馈</div>
            <img className="feedback_bg_img" src={feedback_bg}></img>
          </div>
          <div className="content_box">
            {
              boxContentItem
            }
          </div>
        </div>
        <Footer></Footer>
      </div>
    );
  }
  onTabClick (key) {
    this.setState({
      activeKey: key
    });
  }
  changeFeedback () {
    let title = this.state.titleInputValue;
    let content = this.state.contentInputValue;
    let mobileNo = this.state.mobileNoInputValue;
    if (!title || !title.length) {
      message.error("反馈标题不能为空");
      return;
    }
    if (!content || !content.length) {
      message.error("反馈内容不能为空");
      return;
    }
    let params = {
      noteId: this.state.materialInfo.id,
      title: title,
      content: content
    };
    if (mobileNo && mobileNo.length) {
      if (/^1\d{10}$/g.test(mobileNo)) {
        params.mobileNo = mobileNo;
      }
    }
    if (window.confirm("您确定要修改反馈吗？")) {
      http.other("/access/api/idesupport/notes", "PUT", params, response => {
        if (response && response.result) {
          message.success("修改成功");
          let timer = setTimeout(() => {
            clearTimeout(timer);
            this.backToTop();
          }, 2000);
        }
      });
    }
  }
  deleteFeedback () {
    if (window.confirm("您确定要删除反馈吗？")) {
      http.other("/access/api/idesupport/notes", "DELETE", {
        noteId: this.state.materialInfo.id
      }, response => {
        if (response && response.result) {
          message.success("删除成功");
          let timer = setTimeout(() => {
            clearTimeout(timer);
            this.backToTop();
          }, 2000);
        }
      });
    }
  }
  getMaterialStatus (replyContent) {
    let map = {};
    if (replyContent != "") {
      map.str = "已回复";
      map.color = "#52C41A";
      map.status = "1";
    } else {
      map.str = "未回复";
      map.color = "#F04040";
      map.status = "0";
    }
    return map;
  }
  backToTop () {
    this.setState({
      boxContentItemType: 0
    }, () => {
      this.notesListAccess();
    })
  }
  feedbackItemClick (data, type) {
    data.feedType = type;
    if (type == 0) {
      this.setState({
        materialInfo: data,
        boxContentItemType: 3
      });
    } else if (type == 1) {
      this.setState({
        materialInfo: data,
        boxContentItemType: 2,
        titleInputValue: data.title,
        contentInputValue: data.content,
        mobileNoInputValue: data.mobileNo
      });
    }
  }
  titleInputOnChange (e) {
    let _this = this;
    (global.dobounce(function () {
      _this.setState({
        titleInputValue: e.target.defaultValue
      })
    }, 1000)());
  }
  contentInputOnChange (e) {
    let _this = this;
    (global.dobounce(function () {
      _this.setState({
        contentInputValue: e.target.defaultValue
      })
    }, 1000)());
  }
  mobileNoInputOnChange (e) {
    let _this = this;
    (global.dobounce(function () {
      _this.setState({
        mobileNoInputValue: e.target.defaultValue
      })
    }, 1000)());
  }
  feedbackClick () {
    this.setState({
      boxContentItemType: 1
    })
  }
  submitClick () {
    let title = this.state.titleInputValue;
    let content = this.state.contentInputValue;
    let mobileNo = this.state.mobileNoInputValue;
    if (!title || !title.length) {
      message.error("反馈标题不能为空");
      return;
    }
    if (!content || !content.length) {
      message.error("反馈内容不能为空");
      return;
    }
    this.createNotes(title, content, mobileNo);
  }
  createNotes (title, content, mobileNo) {
    let params = {
      title: title,
      content: content
    }
    if (mobileNo && mobileNo.length) {
      if (/^1\d{10}$/g.test(mobileNo)) {
        params.mobileNo = mobileNo;
      }
    }

    http.post("/access/api/idesupport/notes", params, response => {
      if (response && response.result) {
        message.success("反馈成功,感谢您的宝贵意见~");
        let timer = setTimeout(() => {
          clearTimeout(timer);
          this.backToTop();
        }, 2000);
      }
    });
  }
  refreAccessFeedbackList () {
    this.setState({
      pageAccessNo: this.state.pageAccessNo++
    }, () => {
      this.notesListAccess();
    });
  }
  refrePublicFeedbackList () {
    this.setState({
      pagePublicNo: this.state.pagePublicNo++
    }, () => {
      this.notesListPublic();
    });
  }
  notesListAccess () {
    http.get("/access/api/idesupport/notes", {
      pageNo: this.state.pageAccessNo,
      pageSize: this.state.pageSize
    }, response => {
      if (response && response.result && response.result.length) {
        let dataArr = response.result;
        console.log(dataArr);
        this.setState({
          feedbackList: {
            all: this.state.feedbackList.all,
            my: dataArr
          }
        });
      } else {
        this.setState({
          feedbackList: {
            all: this.state.feedbackList.all,
            my: []
          }
        });
      }
    });
  }
  notesListPublic () {
    http.get("/public/api/idesupport/notes", {
      pageNo: this.state.pagePublicNo,
      pageSize: this.state.pageSize
    }, response => {
      if (response && response.result && response.result.length) {
        let dataArr = response.result;
        console.log(dataArr);
        this.setState({
          feedbackList: {
            all: dataArr,
            my: this.state.feedbackList.my
          }
        });
      }
    });
  }
}
function mapStateToProps (state) {
  return {
    user_info_data: state.user_info_data
  };
}
export default connect(mapStateToProps)(Feedback);